var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3083 13.3333C20.935 12.2742 19.9553 11.5484 18.8333 11.5H15.1667C13.6479 11.5 12.4167 12.7312 12.4167 14.25C12.4167 15.7688 13.6479 17 15.1667 17H18.8333C20.3521 17 21.5833 18.2312 21.5833 19.75C21.5833 21.2688 20.3521 22.5 18.8333 22.5H15.1667C14.0447 22.4516 13.0649 21.7258 12.6917 20.6667",
    stroke: "#ffffff",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 8.75C17.875 8.26675 17.4832 7.875 17 7.875C16.5167 7.875 16.125 8.26675 16.125 8.75H17.875ZM16.125 11.5C16.125 11.9832 16.5167 12.375 17 12.375C17.4832 12.375 17.875 11.9832 17.875 11.5H16.125ZM17.875 22.5C17.875 22.0168 17.4832 21.625 17 21.625C16.5167 21.625 16.125 22.0168 16.125 22.5H17.875ZM16.125 25.25C16.125 25.7332 16.5167 26.125 17 26.125C17.4832 26.125 17.875 25.7332 17.875 25.25H16.125ZM16.125 8.75V11.5H17.875V8.75H16.125ZM16.125 22.5V25.25H17.875V22.5H16.125Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.f95fb77b30ed3debbe00cd820b655f03.svg";
export { ForwardRef as ReactComponent };